<template>
  <div class="row">
    <div class="col-lg-12">
      <iq-card>
        <div class="iq-card-body p-0">
          <div class="iq-edit-list">
            <tab-nav :pills="true" id="pills-tab" class="nav nav-pills d-flex align-items-center justify-content-center profile-feed-items edit-profile">
              <tab-nav-items class="col-sm-3 p-0" :active="true" id="pills-peronal-tab" href="#personal-information" ariaControls="pills-personal" role="tab" :ariaSelected="true" title="Profil Bilgileri" />
              <tab-nav-items class="col-sm-3 p-0" :active="false" id="pills-password-tab" href="#chang-pwd" ariaControls="pills-password" role="tab" :ariaSelected="false" title="Şifre Değiştir" />
              <tab-nav-items class="col-sm-3 p-0" :active="false" id="pills-sms-tab" href="#emailandsms" ariaControls="pills-sms" role="tab" :ariaSelected="false" title="Email ve SMS" />
              <tab-nav-items class="col-sm-3 p-0" :active="false" id="pills-contact-tab" href="#manage-contact" ariaControls="pills-contact" role="tab" :ariaSelected="false" title="Kişileri Yönet" />
            </tab-nav>
          </div>
        </div>
      </iq-card>
    </div>
    <div class="col-lg-12">
      <div class="iq-edit-list-data">
        <div class="tab-content">
          <tab-content-item :active="true" id="personal-information" aria-labelled-by="pills-peronal-tab">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title">Kişisel Bilgiler</h4>
              </template>
              <template v-slot:body>
                <form>
                  <div class="form-group row align-items-center">
                    <div class="col-md-12">
                      <div class="profile-img-edit">
                        <img class="profile-pic" src="@/assets/images/user/11.png" alt="profile-pic">
                        <div class="p-image">
                          <i class="ri-pencil-line upload-button text-white"></i>
                          <input class="file-upload" type="file" accept="image/*"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class=" row align-items-center">
                    <div class="form-group col-sm-6">
                        <label for="fname"  class="form-label">First Name:</label>
                        <input type="text" class="form-control" id="fname" placeholder="Ahmet">
                    </div>
                    <div class="form-group col-sm-6">
                        <label for="lname" class="form-label">Last Name:</label>
                        <input type="text" class="form-control" id="lname" placeholder="Mehmet">
                    </div>
                    <div class="form-group col-sm-6">
                        <label for="uname" class="form-label">User Name:</label>
                        <input type="text" class="form-control" id="uname" placeholder="Ahmet@">
                    </div>
                    <div class="form-group col-sm-6">
                        <label for="cname" class="form-label">City:</label>
                        <input type="text" class="form-control" id="cname" placeholder="İstanbul">
                    </div>
                    <div class="form-group col-sm-6">
                        <label class="form-label d-block">Gender:</label>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio10" value="option1">
                            <label class="form-check-label" for="inlineRadio10"> Erkek</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio11" value="option1">
                            <label class="form-check-label" for="inlineRadio11">Kadın</label>
                        </div>
                    </div>
                    <div class="form-group col-sm-6">
                        <label for="dob" class="form-label">Doğum Tarihi:</label>
                        <input  class="form-control" id="dob" placeholder="1984-01-24">
                    </div>
                    <div class="form-group col-sm-6">
                        <label class="form-label">Evlilik Durumu:</label>
                    <select class="form-select" aria-label="Default select example">
                            <option selected="">Bekar</option>
                            <option>Evli</option>
                            <option>Dul</option>
                            <option>Boşanmış</option>
                            <option>Ayrı </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-6">
                        <label class="form-label">Yaş:</label>
                        <select class="form-select" aria-label="Default select example 2">
                        <option>46-62</option>
                        <option>63 > </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-6">
                        <label class="form-label">Konum:</label>
                        <select class="form-select" aria-label="Default select example 3">
                        <option>Kanada</option>
                        <option>USA</option>
                        <option selected="">Türkiye</option>
                        <option>Almanya</option>
                        <option>Afrika</option>
                        </select>
                    </div>
                    <div class="form-group col-sm-6">
                        <label class="form-label">İl:</label>
                        <select class="form-select" aria-label="Default select example 4">
                            <option>İstanbul</option>
                            <option>Ankara</option>
                            <option selected="">Bursa</option>
                            <option>Çanakkale</option>
                            <option>Yalova</option>
                        </select>
                    </div>
                    <div class="form-group col-sm-12">
                        <label class="form-label">Adres:</label>
                        <textarea class="form-control" name="address" rows="5" style="line-height: 22px;">
                        Holder Doldur
                        </textarea>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-primary me-2">Kaydet</button>
                  <button type="reset" class="btn bg-soft-danger">İptal</button>
                </form>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item :active="false" id="chang-pwd" aria-labelled-by="pills-password-tab">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title">Parolayı Değiştir</h4>
              </template>
              <template v-slot:body>
                <form>
                  <div class="form-group">
                    <label for="cpass" class="form-label">Şuanki Parola:</label>
                    <a href="javascripe:void();" class="float-end">Parolamı Unuttum</a>
                    <input type="Password" class="form-control" id="cpass" value="">
                  </div>
                  <div class="form-group">
                    <label for="npass" class="form-label">Yeni Parola:</label>
                    <input type="Password" class="form-control" id="npass" value="">
                  </div>
                  <div class="form-group">
                    <label for="vpass" class="form-label">Parolayı Doğrula:</label>
                    <input type="Password" class="form-control" id="vpass" value="">
                  </div>
                  <button type="submit" class="btn btn-primary me-2">Kaydet</button>
                  <button type="reset" class="btn bg-soft-danger">İptal</button>
                </form>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item :active="false" id="emailandsms" aria-labelled-by="pills-sms-tab">
            <iq-card>
              <template v-slot:headerTitle>
                <h4 class="card-title">Email ve SMS</h4>
              </template>
              <template v-slot:body>
                <form>
                  <div class="form-group row align-items-center">
                    <label class="col-md-3" for="emailnotification">Email Bildirimi:</label>
                    <div class="col-md-9 form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked11" checked>
                      <label class="form-check-label" for="flexSwitchCheckChecked11">Kontrol</label>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-md-3" for="smsnotification">SMS Bildirimi(daha sonra):</label>
                    <div class="col-md-9 form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked12" checked>
                        <label class="form-check-label" for="flexSwitchCheckChecked12">Kontrol</label>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-md-3" for="npass">Email Almak İstediğin Durumlar :</label>
                    <div class="col-md-9">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault12">
                        <label class="form-check-label" for="flexCheckDefault12">
                            Yeni bildirim
                        </label>
                      </div>
                      <div class="form-check d-block">
                        <input class="form-check-input" type="checkbox" value="" id="email02">
                        <label class="form-check-label" for="email02">Direk mesaj</label>
                      </div>
                      <div class="form-check d-block">
                        <input type="checkbox" class="form-check-input" id="email03" checked="">
                        <label class="form-check-label" for="email03">Birisi seni bağlantılarına ekledi</label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row align-items-center">
                    <label class="col-md-3" for="npass">Diğer seçenek</label>
                    <div class="col-md-9">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="email04">
                        <label class="form-check-label" for="email04">
                            secenek_1
                        </label>
                      </div>
                      <div class="form-check d-block">
                        <input class="form-check-input" type="checkbox" value="" id="email05">
                        <label class="form-check-label" for="email05">secenek_2</label>
                      </div>
                      <div class="form-check d-block">
                        <input type="checkbox" class="form-check-input" id="email06" checked="">
                        <label class="form-check-label" for="email06">secenek_3</label>
                      </div>
                    </div>
                  </div>
                  <button type="submit" class="btn btn-primary me-2">Kaydet</button>
                  <button type="reset" class="btn bg-soft-danger">İptal</button>
                </form>
              </template>
            </iq-card>
          </tab-content-item>
          <tab-content-item :active="false" id="manage-contact" aria-labelled-by="pills-contact-tab">
            <iq-card>
              <template v-slot:headerTitle>
                  <h4 class="card-title">Kişileri Yönet</h4>
              </template>
              <template v-slot:body>
                <form>
                  <div class="form-group">
                    <label for="cno"  class="form-label">İletişim Numarası:</label>
                    <input type="text" class="form-control" id="cno" value="5663265555">
                  </div>
                  <div class="form-group">
                    <label for="email"  class="form-label">Email:</label>
                    <input type="text" class="form-control" id="email" value="deneme@gmail.com">
                  </div>
                  <div class="form-group">
                    <label for="url"  class="form-label">Link:</label>
                    <input type="text" class="form-control" id="url" value="https://friendsquads.com">
                  </div>
                  <button type="submit" class="btn btn-primary me-2">Kaydet</button>
                  <button type="reset" class="btn bg-soft-danger">Çık</button>
                </form>
              </template>
            </iq-card>
          </tab-content-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { socialvue } from '../../config/pluginInit'

export default {
  name: 'ProfileEdit',
  mounted () {
    // socialvue.index()
  },
  data () {
    return {
      user: {
        fname: '',
        lname: '',
        name: '',
        username: '',
        email: '',
        password: '',
        address1: '',
        address2: '',
        company_name: '',
        profile_image: require('../../assets/images/user/11.png'),
        mobile_no: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
        role: '',
        gender: '',
        dob: '',
        url: ''
      },
      currentPassword: '',
      countries: [
        { value: 'Canada', text: 'Canada' },
        { value: 'Niada', text: 'Niada' },
        { value: 'USA', text: 'USA' },
        { value: 'India', text: 'India' },
        { value: 'Africa', text: 'Africa' }
      ],
      states: [
        { value: 'California', text: 'California' },
        { value: 'Florida', text: 'Florida' },
        { value: 'Georgia', text: 'Georgia' },
        { value: 'Connecticut', text: 'Connecticut' },
        { value: 'Louisiana', text: 'Louisiana' }
      ]
    }
  },
  methods: {
    onSubmit () {
      this.user.name = this.user.fname + ' ' + this.user.lname
      this.$router.replace('/user/user-list')
    },
    previewImage: function (event) {
      const input = event.target

      if (input.files && input.files[0]) {
        const reader = new FileReader()

        reader.onload = (e) => {
          this.user.profile_image = e.target.result
        }

        reader.readAsDataURL(input.files[0])
      }
    },
    changePassword: function () {
    }
  }
}
</script>
<style>
.profile-img-edit{
  position: relative;
    display: inline-block;
    height: 150px;
    width: 150px;
}
.profile-pic{
  max-width: 100%;
    display: block;
}
.p-image{
  position: absolute;
    top: auto;
    right: 8px;
    bottom: 10px;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    background: #50b5ff;
    color: #fff;
    border-radius: 50%;
    height: 30px;
    width: 30px;
    line-height: 28px;
    text-align: center;
    font-size: 12px;
    cursor: pointer;
}
.file-upload{
  display: none;
}
.upload-button{
  font-size: 1.5em;
}
</style>
